import { Crucible } from 'types';
import { Box } from '@chakra-ui/layout';
import { useWalletAssets } from 'hooks/query/useWalletAssets';
import { useCrucibleAssets } from 'hooks/query/useCrucibleAssets';
import { useConfig } from 'store/config';
import { useWeb3React } from 'hooks/web3';
import WithdrawFromCrucible from './WithdrawFromCrucible';
import DepositToCrucible from './DepositToCrucible';
import CustomAssetRadio from 'components/shared/CustomAssetsRadio';
import TransferBetweenCrucibles from './TransferBetweenCrucibles';
import TokenWrapper from './TokenWrapper';

type Props = {
  crucible: Crucible;
  transferTabIndex: number;
  setTransferTabIndex: (index: number) => void;
};

const AssetManagement: React.FC<Props> = ({
  crucible,
  transferTabIndex,
  setTransferTabIndex
}) => {
  const {
    data: walletAssets,
    status: walletAssetsStatus,
    isFetching: walletAssetsFetching
  } = useWalletAssets();

  const {
    data: crucibleAssets,
    status: crucibleAssetsStatus,
    isFetching: crucibleAssetsFetching
  } = useCrucibleAssets(crucible?.id);

  const { chainId = 1 } = useWeb3React();
  const { wrappableTokens } = useConfig(chainId).config;

  const wrappableTokenAddresses = wrappableTokens!.flatMap((token) => [
    token.underlyingTokenAddress.toLowerCase(),
    token.wrapperTokenAddress.toLowerCase()
  ]);

  return (
    <Box>
      <Box mb={[4, 8]}>
        <CustomAssetRadio
          value={transferTabIndex}
          onChange={setTransferTabIndex}
        />
      </Box>
      {transferTabIndex === 0 ? (
        <DepositToCrucible
          crucible={crucible}
          walletAssets={walletAssets}
          assetsStatus={walletAssetsStatus}
          assetsFetching={walletAssetsFetching}
        />
      ) : transferTabIndex === 1 ? (
        <WithdrawFromCrucible
          crucible={crucible}
          crucibleAssets={crucibleAssets}
          assetsStatus={crucibleAssetsStatus}
          assetsFetching={crucibleAssetsFetching}
        />
      ) : transferTabIndex === 2 ? (
        <TransferBetweenCrucibles
          crucible={crucible}
          crucibleAssets={crucibleAssets}
          assetsStatus={crucibleAssetsStatus}
          assetsFetching={crucibleAssetsFetching}
        />
      ) : (
        <TokenWrapper
          crucible={crucible}
          walletAssets={walletAssets?.filter((asset) =>
            wrappableTokenAddresses.includes(asset.address.toLowerCase())
          )}
          assetsStatus={walletAssetsStatus}
          assetsFetching={walletAssetsFetching}
        />
      )}
    </Box>
  );
};

export default AssetManagement;
